export default Object.freeze({
  assistiveTeam: 1,
  professionalService: 2,
});
